import script from "./DeliverySchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliverySchedule.vue?vue&type=script&setup=true&lang=js"

import "./DeliverySchedule.vue?vue&type=style&index=0&id=b5a1ae60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5a1ae60"]])

export default __exports__